/**
 * 用户主体类型枚举
 */
export const UserMainBodyType = {
  // 个人用户
  PERSONAL: {
    value: 'personal',
    label: '个人用户'
  },
  
  // 企业用户
  ENTERPRISE: {
    value: 'enterprise',
    label: '企业用户'
  }
}

/**
 * 根据类型值获取枚举对象
 * @param {string} type - 类型值
 * @returns {Object} 枚举对象
 */
export function getUserTypeEnum(type) {
  return Object.values(UserMainBodyType).find(item => item.value === type) || UserMainBodyType.PERSONAL
}

/**
 * 判断是否为个人用户
 * @param {string} type - 类型值
 * @returns {boolean}
 */
export function isPersonalUser(type) {
  return type === UserMainBodyType.PERSONAL.value
}

/**
 * 判断是否为企业用户
 * @param {string} type - 类型值
 * @returns {boolean}
 */
export function isEnterpriseUser(type) {
  return type === UserMainBodyType.ENTERPRISE.value
}

